import styled from 'styled-components';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';
import {PcBox, MobileBox} from './red-tiger-widget.default.box';

export const Pc777Box = styled(PcBox)`
    width: calc((100% / 7) * 2); // 777 doesn't have the right game info sidebar inside arenas
`;

export const RedTigerWidget777Box = styledByDevice(Pc777Box, MobileBox);
